/*
 * Copyright © Manatee. 2026 All Rights Reserved.
 * Proprietary and confidential.
 */

/** Registry edits are Admin/Support; coordinators read. */
export function canEditRegistry(hasRole: (role: string) => boolean): boolean {
  return hasRole("Admin") || hasRole("Support");
}

/** The fax queue is the referral coordinator's work, so CareCoordinator can act. */
export function canWorkFaxes(hasRole: (role: string) => boolean): boolean {
  return canEditRegistry(hasRole) || hasRole("CareCoordinator");
}
